var B = Object.defineProperty;
var V = (n, a, i) => a in n ? B(n, a, { enumerable: !0, configurable: !0, writable: !0, value: i }) : n[a] = i;
var S = (n, a, i) => V(n, typeof a != "symbol" ? a + "" : a, i);
import { jsx as y, jsxs as C } from "react/jsx-runtime";
import { useMemo as k, useEffect as M, useState as b } from "react";
import { LocalMediaStorage as E, isVideoSrc as R, MediaPlayer as $, MediaProvider as w, Poster as D, Track as x } from "@vidstack/react";
import { L as N } from "./Layout-BuPZrP8Y.js";
import { O as K, Q as W } from "./DropdownMultipleSearch-irsQ62vG.js";
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import "@mui/material";
import "@fortawesome/pro-regular-svg-icons";
import "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core";
import "@mui/material/Box";
import "@mui/material/Checkbox";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/pro-light-svg-icons";
import "@mui/material/Stack";
import "@mui/material/Link";
import "@mui/material/Typography";
import "@mui/material/Tooltip";
import "@mui/material/Fade";
import "@mui/material/Button";
import "@fortawesome/pro-regular-svg-icons/faXmark";
import "@mui/material/useAutocomplete";
import "@emotion/cache";
import "@emotion/react";
import "@fortawesome/pro-solid-svg-icons/faCircle";
import "@mui/material/Chip";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "@mui/material/ButtonGroup";
import "@mui/material/Switch";
import "@mui/material/Radio";
import "@mui/material/FormLabel";
import "@mui/material/Autocomplete";
import "@mui/material/FormHelperText";
import "@mui/material/FormControl";
import "@mui/material/OutlinedInput";
import "@mui/material/InputAdornment";
import "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import "@fortawesome/pro-solid-svg-icons/faCheck";
import "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import "react-dropzone";
import "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import "@vidstack/react/icons";
import "@mui/material/Popper";
import "copy-text-to-clipboard";
import "@fortawesome/pro-solid-svg-icons/faExpandWide";
import "@fortawesome/pro-solid-svg-icons/faCompressWide";
import "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import "@fortawesome/pro-solid-svg-icons/faToggleOff";
import "@fortawesome/pro-solid-svg-icons/faEye";
import "react-rnd";
import "react-use";
import "react-hotkeys-hook";
import "@react-spring/web";
import "./AutoScrollContainer-CzyjIY1o.js";
import "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import "./ContentPanel-DRC79oum.js";
import "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import "@fortawesome/pro-solid-svg-icons/faArrowRight";
class U extends E {
  constructor({ storageKeyPrefix: i = "" } = {}) {
    super();
    S(this, "storageKey");
    this.storageKey = `${i ? `${i}:` : ""}guidde:video-player`;
  }
  async getTime() {
    return null;
  }
  async setTime() {
  }
  async getPlaybackRate() {
    return null;
  }
  async setPlaybackRate() {
  }
  async getLang() {
    return null;
  }
  async setLang() {
  }
  async getAudioGain() {
    return null;
  }
  async setAudioGain() {
  }
  async getVideoQuality() {
    return null;
  }
  async setVideoQuality() {
  }
  onChange(i, t, o = this.storageKey) {
    super.onChange(i, t, o);
  }
}
const F = {
  shouldPersistData: !1,
  storageKeyPrefix: "",
  isMuted: !1,
  hasTopTitle: !1,
  topTitleType: "videoOnly",
  hasBottomTitle: !0,
  bottomTitleType: "videoOnly",
  hasSpeedMenu: !0,
  hasCaptions: !0,
  hasChapterNav: !0,
  hasFullscreenMode: !0,
  hasTheatreMode: !1,
  hasMinimizedMode: !1,
  hasPIPMode: !0,
  hasShareButton: !1,
  shareButtonPosition: "right",
  hasCloseButton: !1,
  hasCTAs: !0,
  isPlaylistAutoplayBehaviorOn: !0,
  hasPlaylistAutoplaySwitcher: !0,
  hasPlaylistMenu: !0,
  hasPlaylistControlsOnly: !1,
  hasPauseScreen: !1,
  hasWatermark: !1,
  hasEndScreen: !1,
  hasBranding: !1,
  hasContextMenu: !1,
  canRenderWithoutVideo: !1
}, G = F, ye = ({ video: n, playlist: a, playerProps: i }) => {
  var P, T;
  const t = { ...G, ...i }, o = K(a ?? [], {
    isPlaylistAutoplayBehaviorOn: t.isPlaylistAutoplayBehaviorOn,
    isAutoplay: t.isAutoplay,
    onAutoplayToggle: t.onAutoplayToggle,
    onPlaylistNav: t.onPlaylistNav
  }), l = k(
    () => new U({ storageKeyPrefix: t.storageKeyPrefix }),
    [t.storageKeyPrefix]
  ), { isCaptionsEnabledInitialValue: p } = t;
  M(() => {
    (async () => {
      if (p === void 0)
        return;
      await l.getCaptions() !== null || await l.setCaptions(p);
    })();
  }, [p, l]);
  const [d, h] = b(1), e = (a == null ? void 0 : a[o.videoIndex]) ?? n, f = new URLSearchParams(window.location.search), u = (e == null ? void 0 : e.startTime) ?? f.get("t"), [m, s] = b(!1);
  M(() => {
    s(!1);
  }, [e == null ? void 0 : e.source]);
  const c = k(
    /* hide controls at the beginning of the video when autoplay is on  */
    () => t.isAutoplay && !m ? 0 : t.controlsDelay ?? 2e3,
    [t.isAutoplay, t.controlsDelay, m]
  );
  if (!t.canRenderWithoutVideo && !(e != null && e.source))
    return null;
  const O = R({ src: e == null ? void 0 : e.source, type: "" });
  return /* @__PURE__ */ y(W.Provider, { value: o, children: /* @__PURE__ */ C(
    $,
    {
      ref: t.playerRef,
      crossOrigin: !0,
      playsInline: !0,
      src: e == null ? void 0 : e.source,
      title: e == null ? void 0 : e.title,
      muted: t.isMuted,
      autoPlay: t.isAutoplay,
      controlsDelay: c,
      hideControlsOnMouseLeave: !0,
      onStarted: () => {
        s(!0);
      },
      playbackRate: d,
      onRateChange: (r) => {
        h(r), typeof t.onSpeedChange == "function" && t.onSpeedChange(r);
      },
      onContextMenu: (r) => {
        t.hasContextMenu || r.preventDefault();
      },
      ...t.mediaLoadStrategy && {
        load: t.mediaLoadStrategy
      },
      ...t.shouldPersistData && {
        storage: l
      },
      ...u && { currentTime: Number(u) },
      ...typeof t.onPlay == "function" && {
        onPlay: t.onPlay
      },
      ...typeof t.onPause == "function" && {
        onPause: t.onPause
      },
      ...typeof t.onMute == "function" && {
        onMediaMuteRequest: t.onMute
      },
      ...typeof t.onUnmute == "function" && {
        onMediaUnmuteRequest: t.onUnmute
      },
      ...typeof t.onVolumeChange == "function" && {
        onMediaVolumeChangeRequest: t.onVolumeChange
      },
      ...typeof t.onFullscreenModeToggle == "function" && {
        onFullscreenChange: t.onFullscreenModeToggle
      },
      ...typeof t.onPIPModeToggle == "function" && {
        onPictureInPictureChange: t.onPIPModeToggle
      },
      ...typeof t.onLoadedData == "function" && {
        onLoadedData: t.onLoadedData
      },
      ...t.hasPlaylistControlsOnly && typeof t.onPlaylistNav == "function" && {
        onEnded: () => {
          var r;
          t.isPlaylistAutoplayBehaviorOn && (o.isAutoplayOn || !t.hasEndScreen) && ((r = t.onPlaylistNav) == null || r.call(t, "next"));
        }
      },
      ...o.isPlaylist && {
        autoPlay: o.isAutoplayOn && o.wasPlayed,
        onEnded: () => {
          t.isPlaylistAutoplayBehaviorOn && (o.isAutoplayOn || !t.hasEndScreen) && o.nextVideo();
        },
        onPlay: () => {
          typeof t.onPlay == "function" && t.onPlay(), o.wasPlayed || o.setWasPlayed(!0);
        }
      },
      ...t.hasPauseScreen && {
        "data-has-pause-screen": ""
      },
      ...t.hasEndScreen && {
        "data-has-end-screen": ""
      },
      ...t.hasShareButton && {
        "data-has-share-btn": ""
      },
      ...t.hasCloseButton && {
        "data-has-close-btn": ""
      },
      ...t.hasTopTitle && {
        "data-has-top-title": ""
      },
      children: [
        /* @__PURE__ */ C(w, { children: [
          !!(e != null && e.poster) && /* @__PURE__ */ y(
            D,
            {
              className: "vds-poster",
              src: e.poster
            }
          ),
          !!((P = e == null ? void 0 : e.subtitles) != null && P.length) && e.subtitles.map((r, g) => /* @__PURE__ */ y(
            x,
            {
              kind: "subtitles",
              ...r
            },
            r.src ?? String(g)
          )),
          !!((T = e == null ? void 0 : e.chapters) != null && T.length) && e.chapters.map((r, g) => /* @__PURE__ */ y(
            x,
            {
              kind: "chapters",
              ...r
            },
            r.src ?? String(g)
          ))
        ] }),
        /* @__PURE__ */ y(
          N,
          {
            playerProps: t,
            thumbnails: e == null ? void 0 : e.thumbnails,
            ctas: e == null ? void 0 : e.ctas,
            shareLink: e == null ? void 0 : e.shareLink,
            translations: e == null ? void 0 : e.translations
          }
        )
      ]
    },
    `${O}${u}`
  ) });
}, de = (n) => [
  {
    label: "English",
    lang: "en-US",
    type: "json",
    content: {
      cues: n.map((a) => ({
        startTime: a.start,
        endTime: a.end,
        text: a.title
      }))
    },
    default: !0
  }
], he = (n) => n.map((a) => ({
  startTime: a.start,
  endTime: a.end,
  url: a.thumbnail
})), A = (n, a) => n.findIndex((i) => i.id === a), L = (n, a, i) => n !== "playlist" ? `${i}/playbooks/${a}` : `${i}/playbooks/playlist/${a}`, I = (n) => n ? !n.startsWith("http://") && !n.startsWith("https://") ? `https://${n}` : n : "", fe = (n, a) => n.map((i, t) => {
  var l, p, d, h, e, f, u, m;
  if (!i.cta)
    return null;
  const o = {
    ...i.cta,
    chapterIndex: t,
    type: i.cta.ctaType
  };
  if (delete o.ctaType, o.type === "single") {
    const s = {
      isEnabled: (l = o.action) == null ? void 0 : l.enabled,
      position: (p = o.action) == null ? void 0 : p.position,
      text: (d = o.action) == null ? void 0 : d.text,
      image: (h = o.action) == null ? void 0 : h.image,
      goToType: (e = o.action) == null ? void 0 : e.linkType
    };
    return ((f = o.action) == null ? void 0 : f.linkType) === "goToStep" ? {
      ...o,
      action: {
        ...s,
        goTo: A(n, o.action.link)
      }
    } : ((u = o.action) == null ? void 0 : u.linkType) === "guiddeLink" ? {
      ...o,
      action: {
        ...s,
        goToMode: o.action.mode,
        goTo: L(o.action.mode, o.action.link, a),
        goToId: o.action.link
      }
    } : ((m = o.action) == null ? void 0 : m.linkType) === "externalLink" ? {
      ...o,
      action: {
        ...s,
        goTo: I(o.action.link)
      }
    } : o;
  }
  return o.type === "multiple" ? {
    ...o,
    actions: (o.actions ?? []).map((s) => {
      const c = {
        isEnabled: s.enabled,
        text: s.text,
        goToType: s.linkType
      };
      return s.linkType === "goToStep" ? {
        ...c,
        goTo: A(n, s.link)
      } : s.linkType === "guiddeLink" ? {
        ...c,
        goToMode: s.mode,
        goTo: L(s.mode, s.link, a),
        goToId: s.link
      } : s.linkType === "externalLink" ? {
        ...c,
        goTo: I(s.link)
      } : null;
    }).filter(Boolean)
  } : null;
}).filter(Boolean);
export {
  ye as V,
  he as a,
  fe as b,
  de as s
};
